export default __webpack_public_path__ + "static/media/hero-bg.60655b96.jpg";